<template>
  <div>
    <template v-if="loadError">
      <d-alert
        show
        theme="warning"
        class="my-4">
        Wczytywanie danych nie powiodło się.
        <a
          href="javascript:window.location.reload();"
          class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
    </template>
    <template v-else>
      <div
        v-if="!allDataLoaded"
        class="overlay-loading">
        <h2 class="preloader isLoading">Trwa ładowanie</h2>
      </div>

      <d-card-header class="border-bottom flex-header">
        <h6 class="m-0">Warunki umowy</h6>
        <template v-if="customView">
          <d-button
            @click.prevent="closeForms"
            theme="primary">
            <i class="material-icons">close</i> Zamknij
          </d-button>
          <d-button
            @click.prevent="saveCondition"
            :class="{
              'ml-2': true,
              'isLoading': submitInProgress
            }"
            theme="success">
            <i class="material-icons">save</i> Zapisz
          </d-button>
        </template>
        <template v-else>
          <CDropdown
            label="Dodaj"
            theme="success"
            @select-new="showNewConditionForm"
            @select-basic="handleBasicConditionPicked"
          />
        </template>

      </d-card-header>
      <d-list-group-item v-if="newConditionForm">
        <d-form-row>
          <d-col class="form-group">
            <label>Termin spełnienia warunku</label>
            <ss-date
              type="text"
              name="payment_date"
              v-model="selectedCondition.completion_date"
              @picked="lar_errors.clear('completion_date')"
              placeholder=""
              />
            <div
              class="invalid-feedback"
              :class="{'d-block': lar_errors.get('completion_date')}"
              v-text="lar_errors.get('completion_date')">
            </div>
          </d-col>
          <d-col class="form-group">
            <label>Status</label>
            <d-checkbox
              class="mt-2 small yes-no"
              toggle
              v-model="selectedCondition.status">
              <template v-if="!selectedCondition.status">Niespełniony</template>
              <template v-else>Spełniony</template>
            </d-checkbox>
          </d-col>
        </d-form-row>
        <div class="form-group">
          <ss-textarea
            v-model="selectedCondition.description"
            name="description"
            label="Opis warunku"
            placeholder="Opis..." />
        </div>
        <template v-if="selectedCondition.status == 1">
          <div class="form-group">
            <label>Data spełnienia warunku</label>
            <ss-date
              type="text"
              name="checked_date"
              v-model="selectedCondition.checked_date"
              @picked="lar_errors.clear('checked_date')"
              :class="{'is-invalid': lar_errors.has('checked_date')}"
              date-format="YYYY-MM-DD"
              placeholder=""
              />
            <div
              class="invalid-feedback"
              :class="{'d-block': lar_errors.get('checked_date')}"
              v-text="lar_errors.get('checked_date')">
            </div>
          </div>
        </template>
      </d-list-group-item>
      <div class="card-body p-0 pb-3 text-center" v-else>
        <table class="table mb-0 responsive-table">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0 text-left align-middle">Opis warunku</th>
              <th scope="col" class="border-0">Termin spełnienia warunku</th>
              <th scope="col" class="border-0">Status</th>
              <th scope="col" class="border-0">Data spełnienia warunku</th>
              <th scope="col" class="border-0">Status zmieniony przez</th>
              <th scope="col" class="border-0 action-cell">Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(condition, index) in conditions"
              :key="condition.id">
              <td class="align-middle text-left">
                <dt>Opis warunku</dt>
                <dd>
                  <span class="contact-note" style="max-width: fit-content;">{{ condition.description }}</span>
                </dd>
              </td>
              <td class="align-middle">
                <dt>Termin spełnienia warunku</dt>
                <dd>{{ condition.completion_date || '-' }}</dd>
              </td>
              <td class="align-middle text-center">
                <dt>Status</dt>
                <dd>
                  <div class="three-state-toggle-wrapper">
                    <label
                      class="label-false text-right"
                      :for="'never-fulfilled-' + condition.id">
                      Nie zostanie spełniony
                    </label>
                    <div
                      :class="{
                        'three-state-toggle': true,
                        'is-never-fulfilled': condition.status === '2',
                        'is-not-fulfilled': condition.status === '0',
                        'is-fulfilled': condition.status === '1'
                      }">
                      <d-form-radio
                        v-model="condition.status"
                        value="2"

                        :id="'never-fulfilled-' + condition.id"
                        :name="'condition-' + condition.id"
                        inline
                        title="Nie zostanie spełniony"
                        @change="updateCondition(condition)" />
                      <d-form-radio
                        v-model="condition.status"
                        value="0"
                        @change="updateCondition(condition)"
                        :id="'not-fulfilled-' + condition.id"
                        :name="'condition-' + condition.id"
                        inline
                        title="Niespełniony" />
                      <label
                        class="label-neutral"
                        :for="'not-fulfilled-' + condition.id">
                        Niespełniony
                      </label>
                      <d-form-radio
                        v-model="condition.status"
                        value="1"
                        @change="handleStatusChange(condition)"
                        :id="'fulfilled-' + condition.id"
                        :name="'condition-' + condition.id"
                        inline
                        title="Spełniony" />
                      <span class="toggle-indicator"></span>
                    </div>
                    <label
                      class="label-true text-left"
                      :for="'fulfilled-' + condition.id">
                      Spełniony
                    </label>
                  </div>
                </dd>
              </td>
              <td class="align-middle">
                <dt>Data spełnienia warunku</dt>
                <dd>
                    <ss-date
                      v-if="condition.status === '1'"
                      type="text"
                      :name="'checked_date_' + condition.id"
                      v-model="condition.checked_date"
                      @picked="updateDateCondition(condition)"
                      date-format="YYYY-MM-DD"
                      placeholder=""
                      />

                  <template v-else>
                    {{ condition.checked_date ? condition.checked_date.slice(0, 10) : '-' }}
                  </template>
                </dd>
              </td>
              <td class="align-middle">
                <dt>Status zmieniony przez</dt>
                <dd>
                  <strong>{{ condition.user_name || '-' }}</strong>
                </dd>
              </td>
              <td class="align-middle text-center">
                <dt>Akcje</dt>
                <dd>
                  <d-button
                    @click.prevent="editCondition(condition)"
                    class="my-1 mr-3"
                    :disabled="removeInProgress">
                    <i class="material-icons">edit</i> Edytuj
                  </d-button>
                  <d-button
                    theme="danger"
                    class="my-1"
                    :disabled="removeInProgress"
                    @click.prevent="removeCondition(condition)">
                    <i class="material-icons">delete</i> Usuń
                  </d-button>
                </dd>
              </td>
            </tr>
            <tr v-if="!conditions.length">
              <td
                colspan="6"
                class="text-info text-center">
                Brak warunków do wyświetlenia.
              </td>
            </tr>
          </tbody>
        </table>
        <ss-pagination
          class="px-3 py-2"
          :meta-data="paginationMetaData"
          :initial-page="currentPage" />
      </div>
    </template>

    <!-- Modal for fulfilled condition date selection -->
    <fulfilled-condition-modal
      :is-visible="fulfilledModalVisible"
      :condition="conditionToFulfill"
      @confirm="confirmFulfilledCondition"
      @close="closeFulfilledModal"
    />
  </div>
</template>

<script>
  import LarErrors from '@/helpers/Errors';
  import SsDate from '@/components/common/SsDate'
  import ListUtils from '@/utils/ListUtils.js';
  import FormUtils from '@/utils/FormUtils.js';
  import SsPagination from '@/components/common/SsPaginationNew';
  import HasPagination from '@/mixins/HasPagination.vue';
  import CDropdown from '@/components/contracts/conditions/molecules/CDropdown.vue';
  import FulfilledConditionModal from '@/components/client/contract-partials/conditions/FulfilledConditionModal.vue';
  import { mapGetters } from 'vuex'

  export default {
    name: 'ContractConditions',
    mixins: [HasPagination],
    components: {
    LarErrors,
    SsDate,
    SsPagination,
    CDropdown,
    FulfilledConditionModal
  },
    data () {
      return {
        selectedCondition: {},
        submitInProgress: false,
        conditions: [],
        isDataSet: false,
        lar_errors: LarErrors,
        loaded: false,
        loadError: false,
        newConditionForm: false,
        removeInProgress: false,
        fulfilledModalVisible: false,
        conditionToFulfill: null
      }
    },
    computed: {
      ...mapGetters([ 'getBasicConditionById' ]),
      allDataLoaded () {
        return this.loaded && this.isDataSet;
      },
      customView () {
        return this.newConditionForm
      },
    },
    mounted () {
      this.selectedCondition.schedule_id = this.$route.params.schedule_id;
      this.loadItemsData();
    },
    methods: {
      closeForms () {
        this.newConditionForm = false;
        this.lar_errors.clear();
        this.resetCondition();
      },
      resetCondition () {
        this.selectedCondition = _.clone(
          {
            completion_date: '',
            description: '',
            checked_date: '',
            schedule_id: this.$route.params.schedule_id,
            status: false
          }
        )
      },
      showNewConditionForm () {
        this.newConditionForm = true;
      },
      handleBasicConditionPicked({ id, date }){
        const basicCondition = this.getBasicConditionById(id);
        this.selectedCondition = _.clone({
          description: basicCondition.value,
          completion_date: date,
          checked_date: '',
          schedule_id: this.$route.params.schedule_id,
          status: false
        })
        this.saveCondition()
        this.resetCondition()
      },
      editCondition (condition) {
        this.selectedCondition = _.clone(condition);
        // Convert status to boolean for checkbox
        this.selectedCondition.status = this.selectedCondition.status == '1';
        this.newConditionForm = true;
      },
      removeCondition (condition) {
        this.removeInProgress = true;

        ListUtils.removeItem(this, {
          endpointBase: '/api/contract-conditions/delete/' + condition.id,
          successTitle: 'Warunek został usunięty',
          successText: '',
          confirmTitle: 'Uwaga',
          confirmText: 'Czy na pewno chcesz usunąć warunek umowy?',
          errorTitle: 'Wystąpił błąd',
          errorText: 'Usuwanie warunku nie powiodło się. Spróbuj ponownie.',
          successAction: () => {
            this.removeInProgress = false;
            this.debouncedLoadFilteredData();
          },
          cancelAction: () => {
            this.removeInProgress = false;
          },
        });
      },
      loadItemsData (callback) {
        ListUtils.loadItemsData(this, {
          method: 'post',
          endpoint: '/api/contract-conditions/items',
          listField: 'conditions',
          pagination: true,
          params: {
            page: this.currentPage,
            where: {
              schedule_id: this.$route.params.schedule_id
            }
          },
          successAction: () => {
            // adjust status field - number to string for radio
            for (let i = 0; i < this.conditions.length; i++) {
              this.conditions[i].status = (this.conditions[i].status).toString();
            }
            this.$nextTick(() => {
              this.isDataSet = true;
              if (callback) {
                callback();
              }
            })
          }
        });
      },
      debouncedLoadFilteredData: _.debounce(function () {
        Vue.set(this, 'loaded', false);
        Vue.set(this, 'loadError', false);
        Vue.set(this, 'isDataSet', false);
        this.loadItemsData();
      }, 250),
      handleStatusChange (condition) {
        // Store the current condition for modal
        this.conditionToFulfill = condition;
        this.fulfilledModalVisible = true;
      },
      confirmFulfilledCondition (fulfilledCondition) {
        // Update the condition
        this.updateCondition(fulfilledCondition);

        // Close the modal and clean up
        this.fulfilledModalVisible = false;
        this.conditionToFulfill = null;
      },
      closeFulfilledModal () {
        this.fulfilledModalVisible = false;
        this.conditionToFulfill = null;
        this.loadItemsData();
      },
      updateDateCondition(condition) {
       this.$nextTick(() => {
        this.updateCondition(condition);
       });
      },
      updateCondition (condition) {
        this.$nextTick(() => {
          FormUtils.submitInBackground({
            endpoint: '/api/contract-conditions/update/' + condition.id,
            params: this.prepareFormDataToSend(condition),
            successAction: (response) => {
              this.loadItemsData();
            },
            failAction: (error) => {
              LarErrors.record(error.data.errors)
            }
          });
        })
      },
      saveCondition () {
        this.submitInProgress = true;
        let endpointUrl = this.selectedCondition.id ? '/api/contract-conditions/update/' + this.selectedCondition.id : '/api/contract-conditions/store';

        FormUtils.submit(this, {
          endpoint: endpointUrl,
          formData: this.prepareFormDataToSend(this.selectedCondition),
          successTitle: 'Warunek został zapisany.',
          successText: '',
          errorTitle: 'Wystąpił błąd',
          errorText: 'Zapisywanie warunku nie powiodło się. Spróbuj ponownie.',
          successAction: (response) => {
            this.loadItemsData(() => this.closeForms());
            this.submitInProgress = false;
          },
          failAction: (error) => {
            this.submitInProgress = false;
            console.log(error);
            LarErrors.record(error.data.errors);
          }
        });
      },
      prepareFormDataToSend (conditionToSend) {
        let formDataToSend = _.clone(conditionToSend);
        formDataToSend.status = Number(formDataToSend.status);

        // Send checked_date only when status is 1 (fulfilled)
        if (formDataToSend.status !== 1) {
          delete formDataToSend.checked_date;
        }

        return formDataToSend;
      }
    }
  }
</script>

<style lang="scss" scoped>
.action-cell, .id-cell{
  width: 210px;
}
.contact-note {
  white-space: inherit;
  text-overflow: inherit;
}
</style>
